module.exports = __webpack_public_path__ + "img/style4.73c8334e.png";